import React from 'react'
import { Link } from 'react-router-dom'
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa'

const Footer = () => {
  return (
    <footer 
      className="py-12 text-white relative overflow-hidden"
      style={{ 
        backgroundColor: '#102D12',
        backgroundImage: "url('/elements.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Watermark overlay for better text readability */}
      <div 
        className="absolute inset-0"
        style={{ 
          backgroundColor: 'rgba(16, 45, 18, 0.7)'
        }}
      ></div>
      
      <div className="container mx-auto px-4 relative z-10 w-full max-w-full min-w-0">
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          {/* Left Section - Logo and Description */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="/regreen-footer.png"
                alt="ReGreen Logo"
                className="h-8 w-auto object-contain"
              />
            </div>
            <p 
              className="text-sm leading-relaxed"
              style={{ color: '#FFFFFF' }}
            >
              Simplifying EPR compliance across<br />
              e-waste, plastic, batteries,<br />
              tyres, and more.
            </p>
          </div>

          {/* Right Section - Navigation Links in Two Columns */}
          <div className="flex justify-start md:justify-end">
            <div className="grid grid-cols-2 gap-8">
              {/* First Column */}
              <ul className="space-y-3 text-left">
                <li>
                  <Link 
                    to="/" 
                    className="text-sm hover:opacity-80 transition-opacity"
                    style={{ color: '#FFFFFF' }}
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/about" 
                    className="text-sm hover:opacity-80 transition-opacity"
                    style={{ color: '#FFFFFF' }}
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    About
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/services" 
                    className="text-sm hover:opacity-80 transition-opacity"
                    style={{ color: '#FFFFFF' }}
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    Service
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/partners" 
                    className="text-sm hover:opacity-80 transition-opacity"
                    style={{ color: '#FFFFFF' }}
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    Partners
                  </Link>
                </li>
              </ul>
              
              {/* Second Column */}
              <ul className="space-y-3 text-left">
                <li>
                  <Link 
                    to="/#terms" 
                    className="text-sm hover:opacity-80 transition-opacity"
                    style={{ color: '#FFFFFF' }}
                  >
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/#privacy" 
                    className="text-sm hover:opacity-80 transition-opacity"
                    style={{ color: '#FFFFFF' }}
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/#contact" 
                    className="text-sm hover:opacity-80 transition-opacity"
                    style={{ color: '#FFFFFF' }}
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section - Copyright and Social Media */}
        <div 
          className="border-t pt-8 flex flex-col md:flex-row justify-between items-center relative z-10"
          style={{ borderColor: 'rgba(160, 160, 160, 0.2)' }}
        >
          <p 
            className="text-sm mb-4 md:mb-0"
            style={{ color: '#FFFFFF' }}
          >
            © 2025 ReGreen. All Rights Reserved.
          </p>
          <div className="flex items-center space-x-4">
            <a 
              href="https://www.facebook.com" 
              target="_blank"
              rel="noreferrer"
              className="text-white hover:opacity-80 transition-opacity"
              aria-label="Facebook"
            >
              <FaFacebook className="text-xl" />
            </a>
            <a 
              href="https://www.instagram.com" 
              target="_blank"
              rel="noreferrer"
              className="text-white hover:opacity-80 transition-opacity"
              aria-label="Instagram"
            >
              <FaInstagram className="text-xl" />
            </a>
            <a 
              href="https://twitter.com" 
              target="_blank"
              rel="noreferrer"
              className="text-white hover:opacity-80 transition-opacity"
              aria-label="X"
            >
              <FaTwitter className="text-xl" />
            </a>
            <a 
              href="https://www.linkedin.com" 
              target="_blank"
              rel="noreferrer"
              className="text-white hover:opacity-80 transition-opacity"
              aria-label="LinkedIn"
            >
              <FaLinkedin className="text-xl" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer

